import { FC } from "react";

import Desktop from "../../../../assets/images/content/pillar-2/units-traded-in-europe/units-traded-in-Europe-section2-desktop.svg";
import Mobile from "../../../../assets/images/content/pillar-2/units-traded-in-europe/units-traded-in-Europe-section2-mobile.svg";

const UnitsTradedInEuropeSection2: FC = () => {
	return (
		<div className="flex flex-col items-center justify-center">
			<img className="hidden md:block w-9/12" src={Desktop} role="presentation" />
			<img className="block md:hidden" src={Mobile} role="presentation" />
		</div>
	);
};

export { UnitsTradedInEuropeSection2 };
